export class User {
  login: string;
  givenName: string;
  familyName: string;
  fullName: string;
  email: string;
  languagePreference: string;
  profileImage: string;
}
